import React, { useEffect, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom';
import { Layout, Drawer, Input } from 'antd';
import { 
    SearchOutlined, 
    CaretDownOutlined
    } from '@ant-design/icons';
import './header.css'
import logo from '../../assets/img/logo.svg'
import darkLogo from '../../assets/img/b-logo.svg'
import userLogo from '../../assets/img/user.svg'
import darkuser from '../../assets/img/darkuser.svg'
import xboxLogo from '../../assets/img/xbox.svg'

const Header = () => {
    let location = useLocation();

    const { Header } = Layout;

    const { Search } = Input;

    const [scroll, setScroll] = useState(false)

    const [showPopOver, setShowPopOver] = useState(false)

    const [showSearch, setShowSearch] = useState(false)

    const [drawerVisible, setDrawerVisible] = useState({
        visible: false,
        childrenDrawer: false
    })

    useEffect(() => {
        function headerscroll() {
            let isTop = window.scrollY;
            if(isTop > 0){
                setScroll(true)
            }else{
                setScroll(false)
            }
        }

        window.addEventListener('scroll', headerscroll);

        return function cleanupListener() {
            window.removeEventListener('scroll', headerscroll);
        };
        
    },[location])

    const showSearchBar = () => {
        setShowSearch(!showSearch)
    }

    const showDrawer = () => {
        setDrawerVisible({
            visible: true
        })
    }

    const showContent = () => {
        setShowPopOver(!showPopOver)
    }

    const onClose = () => {
        setDrawerVisible({
            visible: false
        })
    }

    const showChildrenDrawer = () => {
        setDrawerVisible({
            visible: true,
            childrenDrawer: true
        })
    }

    const onChildrenDrawerClose = () =>{
        setDrawerVisible({
            visible: true,
            childrenDrawer: false
        })
    }
    
    return(
        <div>
            <Header className={`${scroll === false ? '' : 'active_header'}`}>
                <div className={`account_style ${location.pathname === "/account" || location.pathname === "/create-game" ? 'change_header' : ''}`}>
                    <div className="logo">
                        <NavLink exact to="/user-home">
                            <img src={logo} alt="" className={`${location.pathname !== "/create-game" || location.pathname !== "/account" && scroll === true  ? 'show_logo' : 'hide_logo'}`}/>
                            <img src={darkLogo} alt="" className={`${location.pathname === "/account" || location.pathname === "/create-game" && scroll === false ? 'show_logo' : 'hide_logo'}`}/>
                        </NavLink>
                    </div>

                    <div className="header_links">
                        <ul>

                            <NavLink exact to="/user-home">
                                <li className={`${location.pathname === '/user-home' ? 'link_active' : ''}`}>Home</li>
                            </NavLink>

                            <NavLink exact to="/browse">
                                <li className={`${location.pathname === '/browse' ? 'link_active' : ''}`}>Browse</li>
                            </NavLink>

                            <NavLink exact to="/tournament">
                                <li className={`${location.pathname === '/tournament' ? 'link_active' : ''}`}>Tournaments</li>
                            </NavLink>

                            <NavLink exact to="/my-timeline">
                                <li className={`${location.pathname === '/my-timeline' ? 'link_active' : ''}`}>My Timeline</li>
                            </NavLink>

                        </ul>
                    </div>

                    <div className="header_user">

                        <div className="header_search">
                            <SearchOutlined onClick={showSearchBar}/>
                            <div className= {` ${showSearch === false ? 'hidden_content' : 'search_bar'}`}>
                                <Search
                                    placeholder="input search text"
                                    onSearch={value => console.log(value)}
                                    style={{ width: 200 }}
                                />
                            </div>
                        </div>
                        
                        <div className="user_bal">
                            <ul>
                                <li>Bal:</li>
                                <li>₦6,000:06</li>
                            </ul>
                            <ul>
                                <li><CaretDownOutlined /></li>
                            </ul>
                        </div>
                        
                        <div className="user_name">
                            <img src={userLogo} alt="" style = {{ width: '30px' }} className={`${location.pathname !== "/account" ? 'show_logo' : 'hide_logo'}`}/>
                            <img src={darkuser} alt="" style = {{ width: '30px' }} className={`${location.pathname === "/account" ? 'show_logo' : 'hide_logo'}`}/>
                            <div className="user_name_loca">
                                <ul>
                                    <li>Awesome_</li>
                                    <li>Lagos</li>
                                </ul>
                            </div>
                            
                            <div className={` ${showPopOver === false ? 'hidden_content' : 'user_content'}`}>
                                <ul>
                                    <NavLink exact to="/create-game">
                                        <li>
                                            <img src={xboxLogo} alt="" style = {{ width: '20px', marginRight: '10px' }}/> 
                                            Create Game
                                        </li>
                                    </NavLink>
                                    <li> 
                                        <img src={xboxLogo} alt="" style = {{ width: '20px', marginRight: '10px' }}/> 
                                        Deposite Fund
                                    </li>
                                </ul>

                                <hr />

                                <ul>
                                    <NavLink exact to="/account">
                                        <li>Account</li>
                                    </NavLink>
                                    <li>Help Center</li>
                                    <NavLink exact to="/">
                                        <li>Sign out of Playarone</li>
                                    </NavLink>
                                </ul>
                            </div>

                        </div>

                        <div className={`drawer_icon pop_over ${showPopOver === true ? 'active' : ''}`} onClick={showContent}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>

                        <div className={`drawer_icon md_drawer ${drawerVisible.visible === true ? 'active' : ''}`} onClick={showDrawer}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        
                    </div>
                </div>    
            </Header>

            <Drawer placement="bottom" closable={true} onClose={onClose} visible={drawerVisible.visible}>
                <div className="mobile_navlinks">
                    <ul>
                        <NavLink exact to="/user-home">
                            <li className={`${location.pathname === '/user-home' ? 'link_active' : ''}`}>Home</li>
                        </NavLink>
                        <NavLink exact to="/browse">
                            <li className={`${location.pathname === '/browse' ? 'link_active' : ''}`}>Browse</li>
                        </NavLink>
                        <NavLink exact to="/tournament">
                            <li className={`${location.pathname === '/tournament' ? 'link_active' : ''}`}>Tournaments</li>
                        </NavLink>
                        <NavLink exact to="/my-timeline">
                            <li className={`${location.pathname === '/my-timeline' ? 'link_active' : ''}`}>My Timeline</li>
                        </NavLink>
                        <li>Bal: ₦6,000:06</li>
                        <li style={{ margin: '4px' }} onClick={showChildrenDrawer}>
                            <div className="mobuser_name_loca">
                                <img src={userLogo} alt="" style = {{ width: '30px' }}/>
                                <ul>
                                    <li>Awesome_</li>
                                    <li>Lagos</li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
                <Drawer title="User: Awesome_" placement="bottom" height={300} closable={true} onClose={onChildrenDrawerClose} visible={drawerVisible.childrenDrawer}>
                    <div className="mob_user_content">
                        <ul>
                            <NavLink exact to="/create-game">
                                <li>
                                    <img src={xboxLogo} alt="" style = {{ width: '20px', marginRight: '10px' }}/> 
                                    Create Game
                                </li>
                            </NavLink>
                            <li> 
                                <img src={xboxLogo} alt="" style = {{ width: '20px', marginRight: '10px' }}/> 
                                Deposite Fund
                            </li>
                            <NavLink exact to="/account">
                                <li>Account</li>
                            </NavLink>
                            <li>Help Center</li>
                            <NavLink exact to="/">
                                <li>Sign out of Playarone</li>
                            </NavLink>
                        </ul>
                    </div>
                </Drawer>
            </Drawer>
        
        </div>
    );
}

export default Header;